import { render, staticRenderFns } from "./sciprodetaliy.vue?vue&type=template&id=b49a8e84&scoped=true&"
import script from "./sciprodetaliy.vue?vue&type=script&lang=js&"
export * from "./sciprodetaliy.vue?vue&type=script&lang=js&"
import style0 from "./sciprodetaliy.vue?vue&type=style&index=0&id=b49a8e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49a8e84",
  null
  
)

export default component.exports